//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Icon } from 'vant'
import timeIcon from '../../assets/icon/time_icon.png'

export default {
  name: 'CSeamlessRolling',

  components: { Icon },

  props: {
    list: {
      type: Array,
      default: () => {
        const arr = [
          {
            name: '1计算机基础',
            courseDesList: [
              {
                desL: '第一节节',
                iconL: 'friends-o',
                desR: '第一节-第二节',
                iconR: 'location-o',
              },
              {
                desL: '第一节-第二节',
                iconL: 'user-o',
                desR: '第一节-第二节',
                iconR: 'calender-o',
              },
              {
                desL: '第一节-第二节',
                iconL: 'friends-o',
                desR: '第一节-第二节',
                iconR: 'location-o',
              },
              {
                desL: '第一节-第二节',
                iconL: 'user-o',
                desR: '第一节-第二节',
                iconR: 'calender-o',
              },
            ],
          },
        ]

        return arr
      },
    },
  },

  data () {
    return {
      timeIcon,
      scrollMove: null,
    }
  },

  computed: {
    scrollList () {
      const arr = []
      const num = this.list.length > 1 ? 2 : 1

      for (let i = 0; i < num; i++) {
        arr.push({
          ref: `seamlessRollingContainer${i}`,
          list: this.list,
        })
      }

      return arr
    },
  },

  mounted () {
    this.startScrollFn()
  },

  methods: {
    stopScrollFn () {
      clearInterval(this.scrollMove)
    },

    startScrollFn () {
      if (this.list.length === 1) {
        return
      }

      const seamlessRollingContainer0 = document.getElementById('seamlessRollingContainer0')
      this.scrollMove = setInterval(() => {
        if (this.$refs.seamlessRolling) {
          if (this.$refs.seamlessRolling.scrollTop >= seamlessRollingContainer0.offsetHeight) {
            this.$refs.seamlessRolling.scrollTop = 0
          } else {
            this.$refs.seamlessRolling.scrollTop++
          }
        }
      }, 30)
    },
  },
}
